import { i18n } from '@/plugins/i18n'
import { CampaignPlanEMailType, CampaignPlan, CampaignGoal, CampaignPlanInstagramAdType, CampaignStatus } from '@/constants'
import { invertKeyValues } from '@/common/objects'

export const planStr = (key) => {
    const planStr = invertKeyValues(CampaignPlan)[key]

    return planStr ? i18n.t(`campaign.plans.${planStr.toLowerCase()}._`) : 'undefined'
}

export const goalStr = (goal) => {
    const goalStr = invertKeyValues(CampaignGoal)[goal]

    return goalStr ? i18n.t(`campaign.goals.${goalStr.toLowerCase()}._`) : 'undefined'
}

export const emailTypeStrDescription = (type) => {
    const emailTypeStr = invertKeyValues(CampaignPlanEMailType)[type]

    return emailTypeStr ? i18n.t(`campaign.settings.email_types.${emailTypeStr.toLowerCase()}.description`) : 'undefined'
}

export const emailTypeStr = (type) => {
    const emailTypeStr = invertKeyValues(CampaignPlanEMailType)[type]

    return emailTypeStr ? i18n.t(`campaign.settings.email_types.${emailTypeStr.toLowerCase()}._`) : 'undefined'
}

export const instagramAdTypeStr = (adType) => {
    const emailTypeStr = invertKeyValues(CampaignPlanInstagramAdType)[adType]

    return emailTypeStr ? i18n.t(`campaign.settings.instagram_ad_types.${emailTypeStr.toLowerCase()}._`) : 'undefined'
}

export const statusStr = (goal) => {
    const statusStr = invertKeyValues(CampaignStatus)[goal]

    return statusStr ? i18n.t(`campaign.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}

export const statusColor = (goal) => {
    const colors = {
        [CampaignStatus.PENDING]: 'warning',
        [CampaignStatus.APPROVED]: 'primary',
        [CampaignStatus.RUNNING]: 'info',
        [CampaignStatus.STOPPED]: 'secondary',
        [CampaignStatus.CANCELLED]: 'danger',
        [CampaignStatus.FINISHED]: 'success',
    }
    return colors[goal] || 'secondary'
}